import { SearchResultChannelItem } from 'pages/SearchResultPage/SearchResultTypes/ChannelResult/ChannelResult'

export type ChannelTeamItem = SearchResultChannelItem & { id?: string }

export interface SignupValues
  extends SignupFirstStepValues,
    SignupSecondStepValues {}

export interface SignupFirstStepValues {
  firstName: string
  lastName: string
  phone: string | undefined
  countryCode: string
  gender: string
  birthYear: string
}

export interface SignupSecondStepValues {
  email: string
  confirmEmail: string
  password: string
  confirmPassword: string
  privacyPolicyChecked: boolean
  emailConsent?: boolean
}

export enum SignupStep {
  First = 'first',
  Second = 'second',
  ThirdStep = 'thirdStep',
  Success = 'success'
}
